//angular imports
import {
    Injectable,
    OnDestroy
} from '@angular/core';

//ngx imports
import { IndividualConfig, ToastrService } from 'ngx-toastr';

// //local imports
import { Messenger } from '@app/shared';

import { 
    ToastComponent, 
    ToastLevel, 
    ToastMessage 
} from '@app/components';

@Injectable({
    providedIn: 'root',
})
export class ToastService implements OnDestroy {

    constructor(
        private toastr: ToastrService,
        private messenger: Messenger) { }

    public startListening() {
                         
        //TODO:DIW:Dedupe, gather messages in a short time frame into a single toast
        this.messenger.subscribe(this, ToastMessage, (message: ToastMessage) => {
                       
            let payload: Partial<IndividualConfig<ToastMessage>> = {
                timeOut: 5000,
                progressBar: true,
                positionClass: 'toast-top-right',
                toastClass: 'ngx-toastr',
                closeButton: true,
                toastComponent: ToastComponent, // Use the custom component for the toast
                payload: message, // Pass the message object as payload                                    
            };

            switch(message.level){
                case ToastLevel.Information:
                    this.toastr.info('', '', payload);
                    break;
                case ToastLevel.Success:
                    this.toastr.success('', '', payload);
                    break;
                case  ToastLevel.Warning:
                    this.toastr.warning('', '', payload);
                    break;
                default:
                    this.toastr.show('', '', payload);
                    break;
            }


        });
    }

    ngOnDestroy() {
        this.messenger.unsubscribeByOwner(this);
    }
}


